import { Typography, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import ModalWindow from "@/components/ModalWindow";
import { pinwheelPalette } from "@/styles/theme";
import googlePlayBadge from "@/assets/icons/google-play-badge.svg";
import appStoreBadge from "@/assets/icons/app-store-badge.svg";
import pinwheelAppIcon from "@/assets/icons/pinwheel-icon-v2.png";
import { deviceType, platform } from "@/util/helper";
import { DeviceType } from "@/openapi";

export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.pinwheel.caregiver";
export const APP_STORE_URL = "https://apps.apple.com/us/app/pinwheel-caregiver/id1552380890";

interface Props {
  open: boolean;
  onClose: () => void;
}

export const AtaDownloadDialog = ({ open, onClose }: Props) => {
  const { t } = useTranslation("common");
  const isUpdate = deviceType === DeviceType.Mobile;

  return (
    <ModalWindow
      showModal={open}
      setShowModal={onClose}
      headerText={isUpdate ? t("updateCaregiverApp") : t("downloadCaregiverApp")}
      cancelButtonText={t("close")}
      renderBody={() => (
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2.5, pt: 1, pb: 1 }}>
          <Box component="img" src={pinwheelAppIcon} alt="Pinwheel" sx={{ width: 72, height: 72, borderRadius: "18px" }} />
          <Typography variant="body1" textAlign="center" color={pinwheelPalette.black[60]}>
            {isUpdate ? t("updateCaregiverAppDesc") : t("downloadCaregiverAppDesc")}
          </Typography>
          <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, gap: 1.5, alignItems: "center" }}>
            {platform !== "android" && (
              <Box component="a" href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">
                <Box component="img" src={appStoreBadge} alt={t("downloadOnAppStore")} sx={{ height: 54, width: "auto", display: "block" }} />
              </Box>
            )}
            {platform !== "ios" && (
              <Box component="a" href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer">
                <Box
                  component="img"
                  src={googlePlayBadge}
                  alt={t("getItOnGooglePlay")}
                  sx={{ height: 54, width: "auto", display: "block" }}
                />
              </Box>
            )}
          </Box>
        </Box>
      )}
    />
  );
};
